import React from 'react';
import AppFavicon from '../components/AppFavicon';
import { ClaudeTileMark, ChatGptMark, CursorMark } from '../pages/ConnectClaude/connectClients';

// Display identity for an OAuth grant, matched on `clientHost` — the only fact we
// verified about a client. `clientName` is attacker-chosen so it never picks the
// mark; unknown hosts fall back to a favicon, then a neutral shield.

const KNOWN_CLIENTS = [
  { pattern: /(^|\.)claude\.(ai|com)$/, label: 'Claude', Mark: ClaudeTileMark },
  { pattern: /(^|\.)(chatgpt|openai)\.com$/, label: 'ChatGPT', Mark: ChatGptMark },
  { pattern: /(^|\.)cursor\.(com|sh)$/, label: 'Cursor', Mark: CursorMark },
];

// A CIMD client_id is itself an https URL, so it carries the host as a fallback.
const grantHost = (grant) => {
  if (grant?.clientHost) return grant.clientHost;
  try {
    return new URL(grant?.clientId).host;
  } catch {
    return null;
  }
};

const matchClient = (host) => (host ? KNOWN_CLIENTS.find((c) => c.pattern.test(host)) : undefined);

// Card routing — Claude and ChatGPT have their own; the MCP card takes the rest.
export const isClaudeGrant = (grant) => matchClient(grantHost(grant))?.label === 'Claude';
export const isChatGptGrant = (grant) => matchClient(grantHost(grant))?.label === 'ChatGPT';

/**
 * @returns {{label: string, host: string|null, Mark: React.ComponentType<{className?: string}>}}
 */
export const resolveClientIdentity = (grant) => {
  const host = grantHost(grant);
  const known = matchClient(host);
  if (known) return { label: known.label, host, Mark: known.Mark };

  const FaviconMark = ({ className }) => <AppFavicon host={host} className={className} />;
  return { label: host || grant?.clientName || 'Unknown app', host, Mark: FaviconMark };
};
